export default __webpack_public_path__ + "static/media/pipe.f2ea53bc.webp";